import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotifyUserService } from '@shared/notify-user.service';
import { AuthenticationService } from 'app/modules-services/auth-services/authentication.service';
import { catchError, tap } from 'rxjs/operators';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent implements OnInit {
    password: string;

    constructor(
        public dialogRef: MatDialogRef<ConfirmModalComponent>,
        private notifyUserService: NotifyUserService,
        private authService: AuthenticationService,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmModalOptions
    ) {}

    ngOnInit(): void {}

    onClose(response: boolean | null) {
        if (!this.data.withPassword) {
            this.dialogRef.close(response);
            return;
        }

        if (!response) return;

        this.authService
            .checkPassword(this.password)
            .pipe(
                tap(() => this.dialogRef.close(response)),
                catchError(() => {
                    this.notifyUserService.showWarn('La password inserita non è corretta', 5000);
                    return [];
                })
            )
            .subscribe();
    }
}

export interface ConfirmModalOptions {
    titolo: string;
    message: string;
    cta: string;
    showCtaAnnulla: boolean;
    withPassword?: boolean;
    buttonLabelAnnulla?: string;
}
